export type CalendarDayFill = 'you' | 'them' | 'none';

export interface CalendarDay {
  day: number;
  fill?: CalendarDayFill;
  pending?: boolean;
  selected?: boolean;
  fadedOut?: boolean;
}

export interface CalendarGridProps {
  weeks: CalendarDay[];
  monthLabel?: string;
}

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function DayCell({
  day,
  fill = 'none',
  pending = false,
  selected = false,
  fadedOut = false,
}: CalendarDay) {
  const classes = [
    'mk-day',
    day === 0 ? 'is-empty' : '',
    fill === 'you' ? 'mk-day--you' : '',
    fill === 'them' ? 'mk-day--them' : '',
    selected ? 'is-selected' : '',
    fadedOut ? 'is-faded' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes}>
      {day !== 0 ? <span className='mk-day__num'>{day}</span> : null}
      {pending && day !== 0 ? <i className='mk-day__dot' /> : null}
    </span>
  );
}

export function CalendarGrid({ weeks, monthLabel }: CalendarGridProps) {
  return (
    <div className='mk-cal'>
      {monthLabel ? <p className='mk-cal__month'>{monthLabel}</p> : null}
      <div className='mk-cal__week'>
        {WEEKDAYS.map((day) => (
          <span key={day} className='mk-cal__weekday'>
            {day}
          </span>
        ))}
      </div>
      <div className='mk-cal__grid'>
        {weeks.map((cell, index) => (
          <DayCell key={index} {...cell} />
        ))}
      </div>
    </div>
  );
}
